<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">C<span class="small">ONTENTS</span></p>
<p class="toc"><a href="#/Text/acknowledgement">Acknowledgements</a></p>
<p class="toc"><a href="#/Text/introduction">Introduction: A City Built on Bones</a></p>
<p class="toc1"><a href="#/Text/part01"><b>Part I: Early Days</b></a></p>
<p class="toc"><a href="#/Text/part01#h1">Fort Brooke</a></p>
<p class="toc"><a href="#/Text/part01#h2">The Fort Brooke Parking Garage</a></p>
<p class="toc"><a href="#/Text/part01#h3">The Legend of Jose Gaspar</a></p>
<p class="toc1"><span href="#/Text/part02" title="Link target outside of Sample"><b>Part II: The Old City Cemetery</b></span></p>
<p class="toc"><span href="#/Text/part02#h1" title="Link target outside of Sample">Oaklawn Cemetery</span></p>
<p class="toc"><span href="#/Text/part02#h2" title="Link target outside of Sample">Dr. John P. Wall</span></p>
<p class="toc"><span href="#/Text/part02#h3" title="Link target outside of Sample">Vincent Martinez de Ybor</span></p>
<p class="toc"><span href="#/Text/part02#h4" title="Link target outside of Sample">Charles Owen</span></p>
<p class="toc"><span href="#/Text/part02#h5" title="Link target outside of Sample">Mayor Lancaster</span></p>
<p class="toc"><span href="#/Text/part02#h6" title="Link target outside of Sample">Darwin Branch Givens</span></p>
<p class="toc"><span href="#/Text/part02#h7" title="Link target outside of Sample">William and Nancy Ashley</span></p>
<p class="toc"><span href="#/Text/part02#h8" title="Link target outside of Sample">St. Paul’s AME Church</span></p>
<p class="toc1"><span href="#/Text/part03" title="Link target outside of Sample"><b>Part III: Downtown</b></span></p>
<p class="toc"><span href="#/Text/part03#h1" title="Link target outside of Sample">The Hotel Floridan</span></p>
<p class="toc"><span href="#/Text/part03#h2" title="Link target outside of Sample">The Tampa Theatre</span></p>
<p class="toc"><span href="#/Text/part03#h3" title="Link target outside of Sample">Duckweed Urban Market</span></p>
<p class="toc"><span href="#/Text/part03#h4" title="Link target outside of Sample">The “Five and Dime” Block</span></p>
<p class="toc"><span href="#/Text/part03#h5" title="Link target outside of Sample">The Old Federal Courthouse</span></p>
<p class="toc"><span href="#/Text/part03#h6" title="Link target outside of Sample">The Tampa Police Memorial</span></p>
<p class="toc"><span href="#/Text/part03#h7" title="Link target outside of Sample">The Mad Russian</span></p>
<p class="toc"><span href="#/Text/part03#h8" title="Link target outside of Sample">Old City Hall and a Clock Named Hortense</span></p>
<p class="toc"><span href="#/Text/part03#h9" title="Link target outside of Sample">The Old Tampa Book Company</span></p>
<p class="toc"><span href="#/Text/part03#h10" title="Link target outside of Sample">The Sykes Building</span></p>
<p class="toc"><span href="#/Text/part03#h11" title="Link target outside of Sample">The Scrub and the Jackson House</span></p>
<p class="toc1"><span href="#/Text/part04" title="Link target outside of Sample"><b>Part IV: Across the River</b></span></p>
<p class="toc"><span href="#/Text/part04#h1" title="Link target outside of Sample">The Falk Theatre</span></p>
<p class="toc"><span href="#/Text/part04#h2" title="Link target outside of Sample">Plant Hall</span></p>
<p class="toc1"><span href="#/Text/part05" title="Link target outside of Sample"><b>Part V: Around the Bay</b></span></p>
<p class="toc"><span href="#/Text/part05#h1" title="Link target outside of Sample">The Sunshine Skyway Bridge</span></p>
<p class="toc"><span href="#/Text/part05#h2" title="Link target outside of Sample">The Ringling Ghosts</span></p>
<p class="toc"><span href="#/Text/part05#h3" title="Link target outside of Sample">Howard W. Blake High School</span></p>
<p class="toc"><span href="#/Text/part05#h4" title="Link target outside of Sample">The Grey Lady</span></p>
<p class="toc"><span href="#/Text/part05#h5" title="Link target outside of Sample">The Sulphur Springs Water Tower</span></p>
<p class="toc1"><span href="#/Text/bibliography" title="Link target outside of Sample">Selected Bibliography</span></p>
<p class="toc"><span href="#/Text/author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?7a6e9c90